import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { BrandService } from './services/brand-config.service';

// Create brand service instance to determine brand class
const brandService = new BrandService();  
document.body.classList.add(brandService.brandClass);

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err)
);
